import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const RevealRequestCard = ({ request, onApprove, onReject, onViewDetails }) => {
  return (
    <div className="bg-card rounded-2xl p-4 md:p-6 elevation-sm border border-border">
      <div className="flex items-start gap-4 mb-4">
        <div className="flex-1 min-w-0">
          <div className="flex items-start justify-between gap-2 mb-3">
            <h4 className="text-base md:text-lg font-semibold text-foreground">
              Identity Reveal Request
            </h4>
            <span className="px-2 py-1 rounded-full text-xs font-medium bg-warning/10 text-warning whitespace-nowrap">
              Pending Review
            </span>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
            <div className="bg-muted/50 rounded-xl p-3">
              <p className="text-xs text-muted-foreground mb-2">Employer</p>
              <div className="flex items-center gap-2">
                <Image 
                  src={request?.employerAvatar} 
                  alt={request?.employerAvatarAlt}
                  className="w-8 h-8 rounded-full object-cover"
                />
                <div className="min-w-0">
                  <p className="text-sm font-medium text-foreground line-clamp-1">{request?.employerName}</p>
                  <p className="text-xs text-muted-foreground line-clamp-1">{request?.employerCompany}</p>
                </div>
              </div>
            </div>
            
            <div className="bg-muted/50 rounded-xl p-3">
              <p className="text-xs text-muted-foreground mb-2">Candidate</p>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center">
                  <Icon name="User" size={16} color="var(--color-primary)" />
                </div>
                <div className="min-w-0">
                  <p className="text-sm font-medium text-foreground">Anonymous Profile</p>
                  <p className="text-xs text-muted-foreground">{request?.candidateIndustry}</p>
                </div>
              </div>
            </div>
          </div>

          <div className="space-y-2 mb-4">
            <div className="flex items-start gap-2">
              <Icon name="Calendar" size={16} className="text-muted-foreground mt-0.5 flex-shrink-0" />
              <div>
                <p className="text-xs text-muted-foreground">Requested Date</p>
                <p className="text-sm text-foreground">{request?.requestedDate}</p>
              </div>
            </div>
            <div className="flex items-start gap-2">
              <Icon name="MessageSquare" size={16} className="text-muted-foreground mt-0.5 flex-shrink-0" />
              <div>
                <p className="text-xs text-muted-foreground">Employer Message</p>
                <p className="text-sm text-foreground line-clamp-2">{request?.message}</p>
              </div>
            </div>
          </div>

          <div className="flex items-center gap-2 mb-4">
            <Icon name={request?.candidateConsent ? 'CheckCircle' : 'AlertCircle'} 
                  size={16} 
                  className={request?.candidateConsent ? 'text-success' : 'text-warning'} />
            <span className="text-sm text-muted-foreground">
              Candidate Consent: {request?.candidateConsent ? 'Granted' : 'Pending'}
            </span>
          </div>
        </div>
      </div>
      <div className="flex flex-col sm:flex-row gap-2">
        <Button 
          variant="outline" 
          size="sm" 
          iconName="FileText" 
          iconPosition="left"
          onClick={() => onViewDetails(request)}
          className="flex-1"
        >
          View Full Details
        </Button>
        <Button 
          variant="success" 
          size="sm" 
          iconName="Check" 
          iconPosition="left"
          onClick={() => onApprove(request)}
          disabled={!request?.candidateConsent}
          className="flex-1"
        >
          Approve Reveal
        </Button>
        <Button 
          variant="destructive" 
          size="sm" 
          iconName="X" 
          iconPosition="left"
          onClick={() => onReject(request)}
          className="flex-1"
        >
          Reject
        </Button>
      </div>
    </div>
  );
};

export default RevealRequestCard;